import { render, staticRenderFns } from "./precautions.vue?vue&type=template&id=003b5c23&scoped=true"
import script from "./precautions.vue?vue&type=script&lang=js"
export * from "./precautions.vue?vue&type=script&lang=js"
import style0 from "./precautions.vue?vue&type=style&index=0&id=003b5c23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003b5c23",
  null
  
)

export default component.exports